<template>
  <!-- `tag="span"` porque o card é um <a>, e o <button> que o v-btn renderia por padrão seria
       marcação inválida dentro dele. Com a tag trocada vêm o `role` e o `tabindex` à mão, que o span
       não tem sozinho.
       `no-drag` porque é a classe que o sortable filtra: sem ela, apertar o botão começaria um
       arrasto.
       `.stop.prevent` porque senão o clique sobe para o card, que abre a instância, e o <a> ainda
       navega. -->
  <v-btn tag="span" variant="text" icon class="card-action no-drag" role="button" tabindex="0"
         :title="title"
         @click.stop.prevent="$emit('act', $event)"
         @keydown.enter.stop.prevent="$emit('act', $event)"
         @keydown.space.stop.prevent="$emit('act', $event)">
    <v-icon size="16">{{ icon }}</v-icon>
  </v-btn>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * Um atalho do cabeçalho do card do Kanban: mover (⇄), editar (✎), desvincular (✕) ou excluir (🗑),
 * nessa ordem (pedido do usuário).
 *
 * Componente porque são todos o mesmo botão — iguais entre si, pequenos e apagados até o mouse
 * chegar —, soltos da tela média para cima e, no celular, o ⋮ que abre o menu deles (ver o
 * KanbanCard). Escrito à mão quatro vezes, um acabaria diferente.
 */
@Component({emits: ['act'], name: 'ontos-card-action'})
class CardAction extends Vue {
  @Prop({type: String, required: true}) readonly icon!: string
  @Prop({type: String, default: ''}) readonly title!: string
}

export default toNative(CardAction)
</script>

<style scoped>
/* Pequenos (pedido do usuário: no desktop, os de antes eram grandes demais): 24px, com ícone de 16.
   Com `tag="span"` o cursor de botão não vem de graça. */
.card-action {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

/* Apagado é o ícone, e ganha contraste ao se aproximar: não competem com o nome do card */
.card-action .v-icon {
  opacity: .55;
}

.card-action:hover .v-icon,
.card-action:focus-visible .v-icon {
  opacity: 1;
}
</style>
